import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import HeroSlider from './components/HeroSlider';
import Piezas from './components/Piezas';
import Servicios from './components/Servicios';
import Bienvenida from './components/Bienvenida';
import Partners from './components/Partners';
import Contacto from './components/Contacto';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import PoliticaPrivacidad from './pages/PoliticaPrivacidad';
import AvisoLegal from './pages/AvisoLegal';
import PoliticaCookies from './pages/PoliticaCookies';
import ServicioDetalle from './pages/ServicioDetalle';

const Home = () => {
  return (
    <div className="bg-white min-h-screen">
      <Header />
      <main>
        <HeroSlider />
        <Servicios />
        <Bienvenida />
        <Piezas />
        <Partners />
        <Contacto />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/servicios/:slug" element={<ServicioDetalle />} />
          <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
          <Route path="/aviso-legal" element={<AvisoLegal />} />
          <Route path="/politica-cookies" element={<PoliticaCookies />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
